import { forwardRef } from 'react';
import classNames from 'classnames';

import { InputProps } from './input-text.types';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      hasError,
      type = 'text',
      readOnly,
      disabled,
      showBorder = true,
      cursorClassName,
      paddingLeftClassName = 'pl-2',
      className = '',
      isChangingInactiveColor = true,
      widthClassName = 'w-full',
      helperText,
      ...props
    },
    ref
  ) => {
    const cursorInput = cursorClassName ?? 'cursor-default';
    const isActive = !readOnly && !disabled;
    return (
      <div className='flex flex-col grow'>
        <div className='relative flex items-center w-full'>
          <input
            readOnly={readOnly}
            disabled={disabled}
            ref={ref}
            className={classNames(
              'text-body-m focus:text-subtitle-m',
              'placeholder-neutral-50 dark:placeholder-neutral-10 placeholder:text-body-m',
              { 'fill-primary focus:fill-primary': showBorder, 'bg-transparent': !showBorder },
              'rounded-md',
              {
                'border-soft focus:border-hard hover:border-hard': !hasError,
                'border-critical-soft focus:border-critical-soft hover:border-critical-soft': hasError,
                'cursor-not-allowed border-soft': !isActive,
                'text-tertiary': !isActive && isChangingInactiveColor,
                'text-primary': isActive || (!isActive && !isChangingInactiveColor),
                'border-0': !showBorder,
                'border ': showBorder,
              },
              `${cursorInput} ${className} ${widthClassName} p-3 focus:outline-hidden focus:ring-0`,
              paddingLeftClassName
            )}
            type={type}
            {...props}
          />
        </div>
        {helperText && !hasError && <p className='mt-1 text-xs text-secondary'>{helperText}</p>}
      </div>
    );
  }
);
